import type * as React from 'react';
import { useEffect, useState } from 'react';

import { useIsClient } from '@crehana/react-hooks';
// biome-ignore lint/style/noRestrictedImports: legacy code - style/noRestrictedImports
import { Col, Container, Row } from '@crehana/ui';
import { MainFooter, MainMenu } from '@crehana/web';
// biome-ignore lint/style/noRestrictedImports: legacy code - style/noRestrictedImports
import { BrowserRouter as Router } from 'react-router-dom';
// biome-ignore lint/style/noRestrictedImports: legacy code - style/noRestrictedImports
import styled from 'styled-components';

import ScrollTopFAB from './components/ScrollTopFAB';
import { CREHANA_LEGAL_AMPLITUDE_PAGE_NAME } from './constants';
import { BASE_URL } from './routes/config';
import RouteSwitch from './routes/RouteSwitch';
import SidebarMenu from './sections/SidebarMenu';
import type { TAppProps } from './types';

const ScrollTop = styled(ScrollTopFAB)`
  bottom: 24px;
`;

// biome-ignore lint/complexity/noBannedTypes: legacy code - complexity/noBannedTypes
export type ExtraState = {};

const App: React.FC<React.PropsWithChildren<TAppProps>> = ({ countryCode }) => {
  const [isScrolled, setIsScrolled] = useState<boolean>(false);

  useEffect(() => {
    const onScroll = () => {
      setIsScrolled(!!document.documentElement.scrollTop);
    };

    window.addEventListener('scroll', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, []);

  return (
    <div>
      <MainMenu
        // @ts-ignore
        countryPrefix={countryCode}
        amplitudePageName={CREHANA_LEGAL_AMPLITUDE_PAGE_NAME}
      />
      <Router basename={BASE_URL}>
        <Container>
          <Row className="items-start">
            <Col className="sticky top-0 pt-24 sm:pt-40" xs={12} sm={4} md={3}>
              <SidebarMenu />
            </Col>
            <Col className="pt-24 sm:pt-40" xs={12} sm={8} md={9}>
              <RouteSwitch />
            </Col>
          </Row>
        </Container>
        <Container
          className={`sticky bottom-0 left-0 right-0 mt-56 w-full flex justify-end h-0 overflow-visible z-7 ${
            isScrolled ? 'cui-is-visible' : 'cui-is-hidden'
          }`}
        >
          <div className="relative w-full h-full overflow-visible">
            <ScrollTop className="absolute right-0" />
          </div>
        </Container>
      </Router>
      <MainFooter />
    </div>
  );
};

const ClientSideApp: React.FC<React.PropsWithChildren<unknown>> = () => {
  const isClient = useIsClient();

  if (!isClient) {
    return null;
  }

  return <App />;
};

export default ClientSideApp;
